import { render } from "./Test2NotificationItem.vue?vue&type=template&id=b43c50fe"
import script from "./Test2NotificationItem.vue?vue&type=script&lang=js"
export * from "./Test2NotificationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__